export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_FAQS_SUCCESS = 'FETCH_FAQS_SUCCESS';
